import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { DeleteTemplateCategoryV2, DeleteTemplateCategoryV2Variables } from './__generated__/DeleteTemplateCategoryV2'

const MUTATION = gql`
  mutation DeleteTemplateCategoryV2($input: DeleteTemplateCategoryInputV2!) {
    deleteColorTemplate: deleteTemplateCategoryV2(input: $input) {
      __typename
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteColorTemplate = () => {
  return useMutation<DeleteTemplateCategoryV2, DeleteTemplateCategoryV2Variables>(MUTATION)
}
